module.exports = __webpack_public_path__ + "static/media/help.95d818eb.mov";


//////////////////
// WEBPACK FOOTER
// ./src/projects/lifedash/src/help.mov
// module id = 598
// module chunks = 0